var _a, _b, _c, _d, _e, _f, _g, _h;
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React from 'react';
import { ChatWidgetDrawer } from './ChatWidgetDrawer';
import { mockConversations } from '../../__fixtures__/conversations';
const meta = {
    title: 'Features/AIChatWidget/ChatWidgetDrawer',
    component: ChatWidgetDrawer,
    decorators: [
        (Story) => (React.createElement("div", { style: { height: '100vh', width: 192, border: '1px solid #DBDBE4', borderRadius: 8, overflow: 'hidden' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Default = {
    args: {
        conversations: mockConversations,
        activeConversationId: null,
        isLoading: false
    }
};
export const WithActiveConversation = {
    args: {
        conversations: mockConversations,
        activeConversationId: 'conv-1',
        isLoading: false
    }
};
export const Loading = {
    args: {
        conversations: [],
        activeConversationId: null,
        isLoading: true
    }
};
export const Empty = {
    args: {
        conversations: [],
        activeConversationId: null,
        isLoading: false
    }
};
/** Finished live chats with InspectPoint Support, as a shortcut above the conversations (newest few). */
export const WithPastSupportChats = {
    args: {
        conversations: mockConversations,
        activeConversationId: 'conv-1',
        isLoading: false,
        pastSupportChats: [
            {
                id: 'support-chat-2',
                conversation_id: (_b = (_a = mockConversations[1]) === null || _a === void 0 ? void 0 : _a.sessionId) !== null && _b !== void 0 ? _b : 'conv-2',
                conversation_title: (_d = (_c = mockConversations[1]) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : 'Panel keeps beeping',
                created_at: '2026-10-22T14:00:00Z',
                ended_at: '2026-10-22T14:40:00Z'
            },
            {
                id: 'support-chat-1',
                conversation_id: (_f = (_e = mockConversations[0]) === null || _e === void 0 ? void 0 : _e.sessionId) !== null && _f !== void 0 ? _f : 'conv-1',
                conversation_title: null,
                created_at: '2026-10-01T09:00:00Z',
                ended_at: '2026-10-01T09:25:00Z'
            }
        ],
        activePastSupportChatId: 'support-chat-2',
        onSelectPastSupportChat: () => undefined
    }
};
/** An unread reply from InspectPoint Support shows as a dot beside the conversation's date. */
export const WithUnreadSupportReply = {
    args: {
        conversations: mockConversations,
        activeConversationId: 'conv-1',
        unreadByConversation: { [(_h = (_g = mockConversations[1]) === null || _g === void 0 ? void 0 : _g.sessionId) !== null && _h !== void 0 ? _h : 'conv-2']: 2 },
        isLoading: false
    }
};
